import { useMutation } from "react-query"
import { DataBaseService } from "../services/DatabaseService"
import { ErrorResponse } from "../types/ErrorResponse"
import { Referral } from "../types/Referral"
import { ReferralPayload } from "../types/ReferralPayload"
import { LanguageOption } from "../types/LanguageOption"
import i18n from "../i18n"

type Variables = {
  referralData: ReferralPayload
  province: string
}

export function usePostReferralData() {
  const lang = i18n.resolvedLanguage as LanguageOption
  const { mutate, isLoading, isSuccess, isError } = useMutation<
    Referral,
    ErrorResponse,
    Variables
  >(["referralPost"], ({ province, referralData }) =>
    DataBaseService.postReferralFormData(province, referralData, lang),
  )
  return { postReferralData: mutate, isLoading, isSuccess, isError }
}
